import store from '@/store'

const routes = [{
    path: '/operations/outbound/:id',
    name: 'warehouseoutbound',
    component: () => import('@/views/main/modules/Operations/Outbound/OutboundGroupComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Outbound',
    },
}]

export default routes;
